import { ActionIcon, ActionIconProps, ElementProps } from "@mantine/core";
import { CSSProperties } from "react";

export type RoundIconButtonProps = ActionIconProps &
  ElementProps<"button", keyof ActionIconProps> & {
    style?: CSSProperties;
  };

const RoundIconButton = ({ children, ...rest }: RoundIconButtonProps) => (
  <ActionIcon variant="subtle" color="gray" radius="xl" size="lg" {...rest}>
    {children}
  </ActionIcon>
);

export default RoundIconButton;
